import { engineComponent } from "neo-common";
import { FrameTimerEventEmitter, CreateFrameTimer, FrameTimerEvents } from "../../Utils/FrameTimer";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { ActionSwitchElement } from "../../CustomComponents/ActionSwitchElement";
import { AnimationElement } from "../../Components/Elements/Graphics/AnimationElement";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { ImageTextElement } from "../../Components/Elements/Texts/ImageTextElement";

@engineComponent(ComponentTypes.DisplayObject)
export class Spot extends ActionSwitchElement {
    delayedTimer: FrameTimerEventEmitter;
    delayedCase: string;
    enabled: boolean;

    constructor() {
        super();

        this.delayedTimer = CreateFrameTimer("delayedTimer");
        this.enabled = false;
    }

    delayedGoToCase(delay: number, delayedCase: string): void {
        this.delayedCase = delayedCase;

        this.delayedTimer.stop();
        this.delayedTimer.removeAllListeners(FrameTimerEvents.Complete);
        this.delayedTimer.on(FrameTimerEvents.Complete, this.delayedToCase.bind(this));
        this.delayedTimer.start(delay);
    }

    private delayedToCase(): void {
        if (this.delayedCase != null || this.delayedCase != "") {
            this.delayedTimer.stop();
            this.delayedTimer.removeAllListeners(FrameTimerEvents.Complete);
            this.goToCase(this.delayedCase);
            this.delayedCase = "";
        }
    }

    setAnimationFrame(frameIndex: number): void {
        const childs = (<SwitchElement>this.getChildElementByName("Diamond")).getAllChildElements();
        for (let key in childs) {
            if (childs[key] instanceof AnimationElement) {
                const elem = <AnimationElement>childs[key];
                elem.playMe(frameIndex);
            }
        }
    }

    updateFSValue(value: string): void {
        this.updateCounterValue("FS", value);
    }

    updateMPValue(value: string): void {
        this.updateCounterValue("MP", value);
    }

    private updateCounterValue(elementName: string, value: string): void {
        const childs = (<SwitchElement>this.getChildElementByName(elementName)).getAllChildElements();
        for (let key in childs) {
            if (childs[key] instanceof ImageTextElement) {
                const elem = <ImageTextElement>childs[key];
                elem.bitmapText.text = "+" + value;
                elem.realign();
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Pick/Spot.ts
 **/